var _circle, _circle2, _g, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _line2, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyParticipants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 304,
    viewBox: "0 0 321 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160.408,
    cy: 152,
    r: 152,
    fill: "#F3F3F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2838_151048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 305,
    height: 304
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.408,
    cy: 152,
    r: 152,
    fill: "#DEDEE9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2838_151048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4673 68.691C60.1458 56.9236 49.8017 48.0896 37.3751 48.0896C27.5089 48.0896 18.94 53.6834 14.6726 61.8693C4.39674 62.9608 -3.5918 71.6584 -3.5918 82.1979C-3.5918 93.4877 5.59161 102.663 16.8916 102.663H61.2724C70.6948 102.663 78.3419 95.0226 78.3419 85.6087C78.3419 76.6041 71.3434 69.3049 62.4673 68.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 32.8671C120.537 28.9447 117.089 26 112.946 26C109.658 26 106.801 27.8646 105.379 30.5932C101.954 30.9571 99.2908 33.8563 99.2908 37.3694C99.2908 41.1327 102.352 44.1911 106.119 44.1911H120.912C124.053 44.1911 126.602 41.6443 126.602 38.5064C126.602 35.5048 124.269 33.0718 121.31 32.8671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.254 63.5871C155.075 57.7034 149.821 53.2864 143.509 53.2864C138.497 53.2864 134.145 56.0833 131.977 60.1762C126.758 60.722 122.7 65.0708 122.7 70.3405C122.7 75.9854 127.365 80.573 133.104 80.573H155.647C160.433 80.573 164.317 76.7529 164.317 72.0459C164.317 67.5436 160.763 63.894 156.254 63.5871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.623 93.3783C257.944 81.6109 268.288 72.7769 280.715 72.7769C290.581 72.7769 299.15 78.3706 303.417 86.5566C313.693 87.6481 321.682 96.3457 321.682 106.885C321.682 118.175 312.498 127.35 301.198 127.35H256.817C247.395 127.35 239.748 119.71 239.748 110.296C239.748 101.291 246.746 93.9922 255.623 93.3783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.564 53.364C230.927 46.6398 237.002 41.5918 244.3 41.5918C250.095 41.5918 255.127 44.7882 257.633 49.4659C263.668 50.0896 268.36 55.0597 268.36 61.0822C268.36 67.5336 262.967 72.7765 256.33 72.7765H230.265C224.731 72.7765 220.24 68.4106 220.24 63.0313C220.24 57.8858 224.351 53.7148 229.564 53.364Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.86 118.714C172.917 118.714 182.578 108.951 182.578 96.8571C182.578 84.7629 172.917 75 160.86 75C148.802 75 139.069 84.7629 139.069 96.8571C139.069 108.951 148.802 118.714 160.86 118.714ZM160.86 133.286C143.935 133.286 110.014 141.81 110.014 158.786V188H211.705V158.786C211.705 141.81 177.784 133.286 160.86 133.286Z",
    fill: "white",
    stroke: "#A6A8BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.278 127.857C94.1117 127.857 85.9664 119.626 85.9664 109.429C85.9664 99.2314 94.1117 91 104.278 91C114.444 91 122.651 99.2314 122.651 109.429C122.651 119.626 114.444 127.857 104.278 127.857ZM104.278 140.143C106.054 140.143 108.075 140.266 110.218 140.45C103.114 145.61 98.1537 152.551 98.1537 161.643V188H61.4082V161.643C61.4082 147.33 90.0084 140.143 104.278 140.143Z",
    fill: "white",
    stroke: "#A6A8BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.387 127.857C227.553 127.857 235.698 119.626 235.698 109.429C235.698 99.2314 227.553 91 217.387 91C207.221 91 199.014 99.2314 199.014 109.429C199.014 119.626 207.221 127.857 217.387 127.857ZM217.387 140.143C215.611 140.143 213.59 140.266 211.446 140.45C218.55 145.61 223.511 152.551 223.511 161.643V188H260.257V161.643C260.257 147.33 231.656 140.143 217.387 140.143Z",
    fill: "white",
    stroke: "#A6A8BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.458496,
    y: 232.279,
    width: 258.671,
    height: 41.7211,
    rx: 4,
    fill: "#A6A8BB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96509,
    y: 227.772,
    width: 266.015,
    height: 40.7211,
    rx: 3.5,
    fill: "#F3F3F7",
    stroke: "#A6A8BB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1531,
    y: 243.961,
    width: 8.34422,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5105,
    y: 243.961,
    width: 50.0653,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100.589,
    y: 243.961,
    width: 50.0653,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 160.667,
    y: 243.961,
    width: 50.0653,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 219.077,
    y: 243.961,
    width: 37.549,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 242.858,
    y1: 227.272,
    x2: 242.858,
    y2: 268.994,
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 243.275,
    y: 239.789,
    width: 28.3703,
    height: 16.6884,
    fill: "#F3F3F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 253.288,
    y: 243.961,
    width: 8.34422,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.52,
    y: 173.007,
    width: 258.671,
    height: 41.7211,
    rx: 4,
    fill: "#A6A8BB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9438,
    y: 168.417,
    width: 266.18,
    height: 40.8867,
    rx: 3.58279,
    fill: "#F3F3F7",
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2151,
    y: 184.688,
    width: 8.34422,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5723,
    y: 184.688,
    width: 50.0653,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 148.651,
    y: 184.688,
    width: 50.0653,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 208.729,
    y: 184.688,
    width: 50.0653,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 267.139,
    y: 184.688,
    width: 37.549,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 290.919,
    y1: 168,
    x2: 290.919,
    y2: 209.721,
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 291.337,
    y: 180.517,
    width: 28.3703,
    height: 16.6884,
    fill: "#F3F3F7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 301.35,
    y: 184.688,
    width: 8.34422,
    height: 8.34422,
    rx: 4.17211,
    fill: "#A6A8BB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyParticipants);
export default __webpack_public_path__ + "static/media/empty_participants.1aa9a47630543976d9569d75ef1b5b15.svg";
export { ForwardRef as ReactComponent };